export default __webpack_public_path__ + "static/liam-a01e39f948c39677d44a72b96a4eeaf9.jpg";